export enum StoreLevelFeatureNames {
  forceSync = 'force sync',
  locationDetails = 'location details',
  reviewResponse = 'review response',
  reviewDraft = 'review draft',
  editFolderContent = 'edit folder content',
  editMenuAssignment = 'edit menu assignment',
  analyticsMonitoring = 'analytics monitoring',
  reviewMonitoringAndInsights = 'review monitoring and insights',
}

export const STORE_LEVEL_PERMISSIONS_IDS: {
  [k in StoreLevelFeatureNames]: string
} = {
  [StoreLevelFeatureNames.forceSync]: 'f56b1fba-f282-40d0-b7ee-287c46646179',
  [StoreLevelFeatureNames.locationDetails]: 'c3f4f654-14d4-4ac9-ae56-5e7978a63932',
  [StoreLevelFeatureNames.reviewResponse]: '16e87d38-0be4-4ba8-b908-90cb216455fd',
  [StoreLevelFeatureNames.reviewDraft]: 'ad06beec-1b19-4fc3-bb36-d66765e90208',
  [StoreLevelFeatureNames.editFolderContent]: '3dc1413d-ff83-4636-9a52-bc36ffe20ec0',
  [StoreLevelFeatureNames.editMenuAssignment]: '172e40df-aac4-4154-bb3f-abc31efd17f2',
  [StoreLevelFeatureNames.analyticsMonitoring]: '3e05321a-42e9-44dd-991c-ece6a7b213cb',
  [StoreLevelFeatureNames.reviewMonitoringAndInsights]: 'dd4f1c0b-ee1d-4750-af50-b7fed37239a6',
}

export interface StorePermissionFeatureProps {
  canAffectStore: true
  id: string
  contextId: string
  name: StoreLevelFeatureNames
}
